__turbopack_context__.v({
  "link": "_3J1WwG_link",
  "link-active": "_3J1WwG_link-active",
  "placeholder": "_3J1WwG_placeholder",
});
